import { Link } from 'foundations-components/transitional/components/Link';
import { OptionComponent } from '../common/OptionComponent';
import { formatFieldOptionsToSelectOptions } from '../../utils/formatFieldOptionsToSelectOptions';
import { getHrefForAsset } from '../../utils/getHrefForAsset';
import { useFieldOptions } from '../../hooks/useFieldOptions';
import { useLoadMoreFieldsHandler } from '../../hooks/useLoadMoreFieldsHandler';
import { useMemo, useState } from 'react';
import { useStrategy } from '../../hooks/useStrategy';
import DSFieldRecord from '../../filterQueryFormat/DSFieldRecord/DSFieldRecord';
import Raven from 'raven-js';
import UISelect from 'UIComponents/input/UISelect';
import { InputStaticLabel } from 'foundations-components/transitional/components/InputStaticLabel';
import { virtualizedMenuRenderer } from 'foundations-components/transitional/utils/virtualizedMenuRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorAssetAndPropertySelect = ({
  field,
  filterFamily,
  onChange,
  inputUse
}) => {
  const {
    getField
  } = useStrategy();
  const {
    options: fieldOptions
  } = useFieldOptions(filterFamily, '');
  const [isFetchingFields, setIsFetchingFields] = useState(true);
  const loadMoreFields = useLoadMoreFieldsHandler();
  const onChangeLocal = evt => {
    const newProperty = getField(filterFamily, evt.target.value);
    if (DSFieldRecord.isDSFieldRecord(newProperty)) {
      onChange(newProperty);
    }
  };
  const {
    label,
    name
  } = field;
  const options = useMemo(() => {
    if (isFetchingFields) {
      return [{
        text: label,
        value: name
      }];
    }
    return formatFieldOptionsToSelectOptions(fieldOptions, filterFamily);
  }, [label, name, fieldOptions, filterFamily, isFetchingFields]);
  const href = getHrefForAsset(filterFamily, field);
  const onOpenChange = evt => {
    const isOpen = evt.target.value;
    if (isOpen) {
      setIsFetchingFields(true);
      loadMoreFields(filterFamily, 0, '').then(() => {
        setIsFetchingFields(false);
      }).catch(error => {
        Raven.captureException(error);
      });
    }
  };
  const selectComponent = /*#__PURE__*/_jsx(UISelect, {
    isLoading: isFetchingFields,
    menuRenderer: virtualizedMenuRenderer,
    minimumSearchCount: 1,
    onChange: onChangeLocal,
    onOpenChange: onOpenChange,
    optionComponent: OptionComponent,
    options: options,
    value: field.name,
    buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
  });
  return href ? /*#__PURE__*/_jsx(InputStaticLabel, {
    text: /*#__PURE__*/_jsx(Link, {
      external: true,
      href: href
    }),
    position: "end",
    children: selectComponent
  }) : selectComponent;
};
export default EditorAssetAndPropertySelect;